import React, { FC, useState } from 'react';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';

import DateFnsUtils from '@date-io/date-fns';
import nlBE from 'date-fns/locale/nl-BE';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import { styled } from '@material-ui/core';
import { Theme } from '@material-ui/core';

type Props = {
  value?: Date;
  onChange: (date?: Date) => void;
};

const StyledKeyboardDatePicker = styled(KeyboardDatePicker)<Theme>(({ theme }) => ({
  background: theme.palette.common.white,
  border: `1px solid ${theme.config.appbarColors.borderColor}`,
  borderRadius: theme.config.defaultBorderRadius,
  padding: theme.spacing(0.5, 0.5, 0.5, 1),
  fontSize: theme.typography.h3.fontSize,
  color: theme.palette.grey['900'],
  '& .MuiInput-underline:before, & .MuiInput-underline:after': {
    display: 'none',
  },
}));

const DeadlinePicker: FC<Props> = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);

  const handleDateChange = (date: MaterialUiPickersDate) => {
    if (!date) {
      onChange();
      return;
    }
    onChange(date);
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={nlBE}>
      <StyledKeyboardDatePicker
        disableToolbar
        variant="inline"
        format="dd/MM/yyyy"
        margin="normal"
        id="date-picker-inline"
        value={value || null}
        onChange={handleDateChange}
        KeyboardButtonProps={{
          'aria-label': 'change date',
        }}
        disablePast
        open={open}
        onAccept={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      />
    </MuiPickersUtilsProvider>
  );
};
export default DeadlinePicker;
